import { render } from "./ChangePasswordView.vue?vue&type=template&id=2464d82e"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__